import { Box, Button, ColumnLayout, Container, Header, SpaceBetween } from '@amzn/awsui-components-react';
import { TimezoneToggle } from '../../../Components/TimezoneToggle';
import CopyText from '../../../utils/copy-text';
import React, { useEffect, useState } from "react";
import { generatePath } from "react-router";
import { JUNO_PLACEMENTCONSTRAINT_OVERVIEW_PATH } from "../../commons/constants";
import { useHistory } from "react-router-dom";

const ValueWithLabel = ({ label, children }) => (
    <div>
        <Box margin={{ bottom: 'xxxs' }} color="text-label">
            {label}
        </Box>
        <div>{children}</div>
    </div>
);

const CollectionGroupDetails = (props) => {
    const [seconds, setSeconds] = useState(0);
    const history = useHistory();
    const [timeElapsed, setTimeElapsed] = useState(0);
    useEffect(() => {
        const time = Math.floor((Date.now()-seconds / 1000 / 60) % 60)
        setTimeElapsed(time)
    });

    return (
        <Container header={<Header variant="h2">Collection Group Details</Header>}>
            {props.collectionGroupDetails ? (
            <ColumnLayout columns={4} variant="text-grid">
                <SpaceBetween size="l">
                    <ValueWithLabel label="Id">
                        <CopyText
                            copyText={props.collectionGroupDetails.id}
                            copyButtonLabel={props.collectionGroupDetails.id}
                            successText="Collection Id copied"
                            errorText="Error while copying Collection id"
                        />
                    </ValueWithLabel>
                    <ValueWithLabel label="Created At">
                        <TimezoneToggle
                            date={new Date(props.collectionGroupDetails.created_date)}
                        />
                    </ValueWithLabel>
                    <ValueWithLabel label="Standby Replicas">
                        {props.collectionGroupDetails.standby_replicas}
                    </ValueWithLabel>
                    <ValueWithLabel label="Generation">
                        {props.collectionGroupDetails.generation ?? '--'}
                    </ValueWithLabel>
                </SpaceBetween>
                <SpaceBetween size="l">
                    <ValueWithLabel label="Name">
                        <CopyText
                            copyText={props.collectionGroupDetails.name}
                            copyButtonLabel={props.collectionGroupDetails.name}
                            successText="Collection Group Name copied"
                            errorText="Error while copying Collection Group Name"
                        />
                    </ValueWithLabel>
                    <ValueWithLabel label="Placement Constraint Id">
                        {props.collectionGroupDetails.placement_constraint_id ? (
                            <React.Fragment>
                                <CopyText
                                    copyText={props.collectionGroupDetails.placement_constraint_id}
                                    copyButtonLabel={''}
                                    successText="Placement Constraint Id copied"
                                    errorText="Placement Constraint copied"
                                />
                                <Button
                                    href={generatePath(JUNO_PLACEMENTCONSTRAINT_OVERVIEW_PATH, {awsAccountId: props.awsAccountId, placementConstraintId: props.collectionGroupDetails.placement_constraint_id})}
                                    variant="link"
                                    onFollow={(event) => {
                                        event.preventDefault();
                                        history.push({
                                            pathname: generatePath(JUNO_PLACEMENTCONSTRAINT_OVERVIEW_PATH, {awsAccountId: props.awsAccountId, placementConstraintId: props.collectionGroupDetails.placement_constraint_id}),
                                            state: {
                                                awsAccountId: props.awsAccountId,
                                                placementConstraintId: props.collectionGroupDetails.placement_constraint_id,
                                                namespace: 'default',
                                            },
                                        });
                                    }}
                                >
                                    <span style={{ color: '#00a1c9' }}>
                                      {props.collectionGroupDetails.placement_constraint_id}
                                    </span>
                                </Button>
                            </React.Fragment>
                        ) : '--'}
                    </ValueWithLabel>
                    <ValueWithLabel label="Number of Collections">
                        {props.collectionGroupDetails.number_of_collections}
                    </ValueWithLabel>
                </SpaceBetween>
                <SpaceBetween size="1">
                    <ValueWithLabel label="Search OCUs">
                        {props.searchOCUsCount ?? '--'}
                    </ValueWithLabel>
                    <ValueWithLabel label="Limits">
                        Min: {props.collectionGroupDetails.capacity_limits?.min_search_capacity_in_ocu ?? '--'} /
                        Max: {props.collectionGroupDetails.capacity_limits?.max_search_capacity_in_ocu ?? '--'}
                    </ValueWithLabel>
                </SpaceBetween>
                <SpaceBetween size="1">
                    <ValueWithLabel label="Indexing OCUs">
                        {props.indexingOCUsCount ?? '--'}
                    </ValueWithLabel>
                    <ValueWithLabel label="Limits">
                        Min: {props.collectionGroupDetails.capacity_limits?.min_indexing_capacity_in_ocu ?? '--'} /
                        Max: {props.collectionGroupDetails.capacity_limits?.max_indexing_capacity_in_ocu ?? '--'}
                    </ValueWithLabel>
                </SpaceBetween>
            </ColumnLayout>
        ) :
            <div>Loading...</div>
            }
        </Container>
    );
};

export { CollectionGroupDetails };

